import { render, staticRenderFns } from "./CausticityManager.vue?vue&type=template&id=85fe8c9e&"
import script from "./CausticityManager.vue?vue&type=script&lang=ts&"
export * from "./CausticityManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports